// Generic role gate. Not currently wired into any page — the codebase
// uses the more specific `role-admin-read` / `role-admin-write`
// middlewares instead. Kept as a stub so Nuxt doesn't emit an "empty
// chunk: require-role" build warning. To enable, set requiredRoles in
// the calling page's definePageMeta and uncomment the body below.
//
//   definePageMeta({
//     middleware: ['require-role'],
//     requiredRoles: ['Advisor', 'Representative']
//   })
export default defineNuxtRouteMiddleware((_to) => {
  // const required = (_to.meta.requiredRoles as string[] | undefined) || []
  // if (!required.length) return
  //
  // const { ensureLoaded, hasAnyRole } = useAuth()
  // await ensureLoaded()
  // if (!hasAnyRole(required)) return navigateTo('/forbidden')
})
